export default function KnowledgeGraph() {
  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold mb-4">Knowledge Graph</h1>
      <p className="text-gray-600">Explore relationships in your knowledge graph</p>
    </div>
  );
}

